import e from"react";import{Header as r}from"./styles.js";const t=({children:t})=>e.createElement(r,{align:"center",variant:"h3"},t);export{t as Headline};
//# sourceMappingURL=Headline.js.map
